import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RegisterService } from '../../services/register.service';
import { OpenRegister, Register } from '../../../../../core/models/register.model';
import { RegisterValidationService } from '../../services/register-validation.service';

@Component({
  selector: 'app-open-register',
  templateUrl: './open-register.component.html',
  styleUrls: ['./open-register.component.scss']
})
export class OpenRegisterComponent implements OnInit {
  value: number;
  isRequired: boolean = false;
  private defaultRegister: Register;
  public loading: boolean;

  constructor(
    private dialogRef: MatDialogRef<OpenRegisterComponent>,
    private registerService: RegisterService,
    private registerValidationService: RegisterValidationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Check if this is a required opening (non-closable)
    if (data && data.isRequired) {
      this.isRequired = true;
      // Configure dialog to prevent closing by escape key or clicking outside
      this.dialogRef.disableClose = true;
    }
  }

  ngOnInit(): void {
    this.loading = true;
    this.registerService.getAllRegisters().subscribe(registers => {
      this.defaultRegister = registers[0];
      this.loading = false;
    });
  }

  onCancel() {
    // Only allow closing if not required
    if (!this.isRequired) {
      this.dialogRef.close();
    }
  }

  onSave() {
    this.loading = true;
    const user = JSON.parse(localStorage.getItem('user'));
    const params: OpenRegister = {
      userId: user.id_utilizador,
      employeeId: user.id_funcionario,
      cashBoxId: this.defaultRegister.bankId,
      initialValue: this.value
    };
    this.registerService.openRegister(params).subscribe(res => {
      this.loading = false;
      // if (res.status === RegisterStatus.HAS_OPEN) {
      // Update the last opening date for this employee
      this.registerValidationService.setLastOpeningDate(user.id_funcionario);
      this.dialogRef.close(1);
      // }
    });
  }
}
